import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-logo-loader',
  templateUrl: './logo-loader.component.html',
  styleUrls: ['./logo-loader.component.scss'],
})
export class LogoLoaderComponent implements OnChanges {
  @Input() delayLogoAnimation = false;
  @Input() delayClose = false;
  @Input() close = false;
  @Input() showLogo = false;
  @Output() animationFinished = new EventEmitter<void>();

  splashScreenVisible = true;
  fadeOut = false;

  ngOnChanges(changes: SimpleChanges): void {
    if ('close' in changes && changes['close'].currentValue) {
      this.fadeOut = true;
    }
  }

  onTextAnimationEnd() {
    sessionStorage.removeItem('hasAuthParams');
    setTimeout(() => {
      if (!this.delayClose) {
        this.fadeOut = true;
        sessionStorage.removeItem('hasAuthParams');
      }
    }, 500);
  }

  onFadeOutEnd() {
    if (this.fadeOut) {
      this.animationFinished.emit();
    }
  }
}
